<template>
  <v-container>
    <v-row style="margin-top: -30px;">
      <v-col cols="12" md="11" class="d-flex align-end">
        <v-row justify="space-between" align="start">
          <h1 style="text-align: left;">
            <span style="color: #222222;">Welcome, </span>
            <span style="color: #0A7EA5;" v-if="eng_name != '  '">{{ eng_name }}!</span>
            <span style="color: #0A7EA5;" v-else>{{ th_name }}</span>
          </h1>
        </v-row>

        <span style="text-align: right;">Current Time: {{ currentTime }}</span>
      </v-col>
    </v-row>
    <v-row :style="{ marginTop: leaveApprove_list.length > 0 ? '10px' : '10px' }" class="mb-3">
      <v-col cols="0" md="1" />
      <v-col cols="12" md="5" style="margin: 0 auto 0 auto;">
        <v-row v-if="sec_acc_my_time_off">
          <v-col cols="12" md="12">
            <v-card class="pa-6" elevation="0" style="height: 330px;">
              <v-row>
                <v-col cols="5" md="5" class="d-flex flex-column justify-center align-center mt-2">
                  <v-row justify="center">
                    <span class="text-h6 font-weight-medium">My Time Off</span>
                  </v-row>
                </v-col>
                <v-col cols="7" md="7">
                  <v-row> </v-row>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col cols="5" md="5" class="d-flex flex-column justify-center align-center mt-5">
                  <v-row justify="center">
                    <v-icon size="50" style="color: #0A7EA5;">mdi-check-circle-outline</v-icon>
                  </v-row>
                </v-col>
                <v-col cols="7" md="7" class="mt-5">
                  <v-row class="d-flex align-center">
                    <h2>{{ vacation_day }}</h2>
                    &nbsp; Days &nbsp;&nbsp;&nbsp;&nbsp;
                    <h2>{{ vacation_hours }}</h2>
                    &nbsp;Hours
                  </v-row>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="5" md="5" class="d-flex flex-column justify-center align-center">
                  <v-row justify="center">
                    <div class="font-weight-medium text-body-1 mt-1">
                      Vacation
                    </div>
                  </v-row>
                </v-col>
                <v-col cols="7" md="7">
                  <v-row style="font-size: 14px;">
                    <span style="font-size: 14px; padding-top: 5px;">Available to book time off</span>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="center" align="center">
                <v-col cols="5" md="5" class="d-flex flex-column justify-center align-center mt-5">
                  <v-row justify="center">
                    <v-icon size="50" style="color: #ffbe5c;">mdi-alert-circle-outline</v-icon>
                  </v-row>
                </v-col>
                <v-col cols="7" md="7" class="mt-5">
                  <v-row class="d-flex align-center">
                    <h2>{{ pending_cont }}</h2>
                    &nbsp; Requests
                  </v-row>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="5" md="5" class="d-flex flex-column justify-center align-center">
                  <v-row justify="center">
                    <div class="font-weight-medium text-body-1 mt-1">
                      Pending
                    </div>
                  </v-row>
                </v-col>
                <v-col cols="7" md="7">
                  <v-row>
                    <span style="font-size: 14px; padding-top: 5px;">Awaiting manager approval</span>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Button Section -->
              <v-row class="mt-7 align-center">
                <v-col cols="12" md="12" class="text-center">
                  <v-btn style="background-color: #0A7EA5; color: white; width: 180px;" to="/my-time-off">
                    My Time Off
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="sec_acc_approve_time_off">
          <v-col cols="12" md="12">
            <v-card class="pa-6" elevation="0" v-if="true">
              <v-row class="d-flex justify-space-between align-center" style="padding-left: 15px;">
                <span style="color: #222222; font-size: 20px; font-weight: 500;">Approve Time Off</span>
                <span class="pt-3 " @click="goToLeaveApprove"
                  style="text-align: right; color: #0A7EA5; cursor: pointer; font-size: 13px; text-decoration: underline; padding-right: 30px;">See
                  All</span>
              </v-row>
              <v-row style="padding-top: 5px;" v-if="leaveApprove_list.length > 0">
                <v-col cols="12" lg="12" sm="12" style="padding: 10px 0px 10px 20px; cursor: pointer;"
                  v-for="item in leaveApprove_list" :key="item.id"
                  @click="goToLeaveApproveById(item.id, item.userid, item.status)" class="hover-bg">
                  <v-row>
                    <v-col cols="12" md="1" class="d-flex flex-column justify-center">
                      <v-row style="margin-top: 5px;">
                        <v-avatar size="40">
                          <v-icon style="
                                font-size: 35px;
                                color: #0A7EA5;
                              ">mdi-clipboard-text-clock-outline</v-icon>
                        </v-avatar>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="11" style="padding-left: 20px; padding-top: 15px;">
                      <v-row class="justify-start">
                        <v-col cols="6" lg="4" md="4">
                          <span style="color: #222222; font-size: 13px;  font-weight: 500;">{{ item.leave_type }}</span>
                        </v-col>
                        <v-col cols="6" lg="7" md="7" class="d-flex justify-end pt-4">
                          <span v-if="item.status_name == 'Approved'" style="
                                color: #06A458; 
                                font-size: 11px; 
                                text-align: right; 
                              ">
                            {{ item.status_name }}
                          </span>
                          <span v-else-if="item.status_name == 'Rejected'"
                            style=" color: red; font-size: 11px; text-align: right; ">
                            {{ item.status_name }}
                          </span>
                          <span v-else style=" color: #ffbe5c; font-size: 11px; text-align: right; ">
                            Pending
                          </span>
                        </v-col>
                      </v-row>
                      <v-row class=" d-flex justify-space-between" style="margin-top: -30px;">
                        <v-col cols="12" lg="12" md="12">
                          <span style="color: #222222; font-size: 11px; padding-right: 10px; ">{{ item.description
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row v-else justify="center" align="center" style="min-height: 80px;">
                <span style="color: #222222; font-size: 20px; font-weight: 500;">
                  No request to approve
                </span>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="5" md="5" style="padding-left: 50px;">
        <v-row v-if="sec_acc_time_attendance">
          <v-col cols="12" md="12">
            <v-card class="pa-6" elevation="0" :style="statusActivity === 'checkin'
              ? 'height: 560px;'
              : 'height: 330px;'
              ">
              <v-row justify="space-between" align="start" style="padding: 0px 10px 0px 10px;">
                <span class="text-h6 ">Time Attendance</span>
                <span class="text" style="padding-top: 5px;">(Today)</span>
              </v-row>
              <v-row v-if="statusActivity == 'checkin'" justify="space-between" align="start"
                style="padding: 10px 10px 0px 10px;">
                <span class="text" style="padding-top: 5px;"><v-icon size="18"
                    style="color: #ff4f45;">mdi-close-circle</v-icon>
                  Status: <b>Not checked in</b></span>
              </v-row>
              <v-row v-if="statusActivity == 'checkin'" justify="space-between" align="end"
                style="padding: 0px 10px 0px 10px;">
                <span class="text" style="padding-top: 5px;"><v-icon size="18"
                    style="color: #4bbe85;">mdi-check-circle</v-icon>
                  Checked In: </span><b>-</b>
              </v-row>
              <v-row v-if="statusActivity == 'checkout'" justify="space-between" align="end"
                style="padding: 10px 10px 0px 10px;">
                <span class="text" style="padding-top: 5px;"><v-icon size="18"
                    style="color: #ff4f45;">mdi-close-circle</v-icon>
                  Status: <b>Not checked out</b></span>
              </v-row>
              <v-row v-if="statusActivity == 'checkout'" justify="space-between" align="end"
                style="padding: 0px 10px 0px 10px;">
                <span class="text" style="padding-top: 5px;"><v-icon size="18"
                    style="color: #4bbe85;">mdi-check-circle</v-icon>
                  Checked In: </span><b>{{ checkindate }}</b>
              </v-row>
              <v-row v-if="statusActivity == 'checkout'" justify="space-between" align="end"
                style="padding: 0px 10px 0px 10px;">
                <span class="text" style="padding-top: 5px;">Worked: </span><b>{{ worker_time }}</b>
              </v-row>
              <v-row justify="space-between" align="start" style="padding: 20px 10px;">
                <v-btn style="background-color: #3682ec; color: white; width: 100%; text-transform: capitalize;"
                  @click="CheckInOut()">
                  {{ statusActivity == "checkout" ? "Check Out" : "Check In" }}
                </v-btn>
              </v-row>
              <v-row justify="space-between" align="start" style="padding: 5px 0px;"
                v-if="statusActivity != 'checkout'">
                <v-col cols="12" id="maps" style="position: relative;">
                  <div id="map" style="height: 250px;"></div>
                  <div v-if="isLocating" style="
      position: absolute; top: 8px; left: 8px;
      background: white; padding: 4px 10px; border-radius: 4px;
      font-size: 12px; box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    ">
                    <v-progress-circular indeterminate size="14" width="2" color="primary" />
                    กำลังค้นหาตำแหน่ง...
                  </div>
                </v-col>
              </v-row>
              <v-row justify="space-between" align="start" style="padding: 5px 10px;">
                <span class="text" style="padding-top: 5px;">Date: <b>{{ datenow_show }}</b></span>
              </v-row>
              <v-row justify="space-between" align="start" style="padding: 0px 10px;">
                <span class="text" style="padding-top: 5px;">Expected Check-Out: <b>{{ expecttime }}</b></span>
              </v-row>
              <!-- <v-row justify="start" align="start" style="padding: 0px 10px;">
                  <span class="text" style="padding-top: 5px;">Location: <b>Bangkok HQ</b></span>
                </v-row> -->
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="sec_acc_out_of_office">
          <v-col cols="12" md="12">
            <v-card class="pa-6" elevation="0">
              <v-row style="padding: 20px 10px 0px 10px;">
                <span class="text-h5" style="font-weight: 700;">Out of Office</span>
              </v-row>
              <v-row style="padding: 0px 10px 10px 10px;">
                <span class="text" style="padding-top: 5px;">Todays’ Leave ({{ leave_number }})</span>
              </v-row>
              <v-row v-if="leave_list.length > 0">
                <v-col cols="12" md="12">
                  <v-row v-for="item in leave_list.slice(0, 5)" :key="item.id" class="d-flex align-center"
                    style="padding: 5px 10px;">
                    <v-avatar size="30">
                      <v-img v-if="item.image_profile != ''" :lazy-src="item.image_profile" max-height="30px"
                        max-width="30px" :src="item.image_profile"></v-img>
                      <v-icon dark style="color: #808080; font-size: 35px;" v-else>
                        mdi-account-circle
                      </v-icon>
                    </v-avatar>

                    <span class="text" style="padding-left: 10px;">
                      {{ item.fullname }}
                    </span>
                    <span class="text" style="padding-left: 10px; color: #676A6D;">
                      {{ item.description }}
                    </span>
                  </v-row>
                </v-col>
              </v-row>
              <v-row v-else justify="center" align="center">
                <span style="font-size: 16px; font-weight: 500;">
                  No one is on leave today.
                </span>
              </v-row>
              <v-row class="justify-end" style="padding: 10px 10px 0px 10px;">
                <a href="/calendar" class="text" style="
                      color: #376294; 
                      text-decoration: none; 
                      cursor: pointer;
                    ">
                  View full calendar &gt;
                </a>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="0" md="1" />
    </v-row>
    <v-dialog v-model="dialogcCheckIn" max-width="300px">
      <v-card style="padding-top: 30px; padding-bottom: 30px;">
        <v-card-title style="padding-bottom: 20px;">
          <v-row justify="center">
            <span class="text-h5 ju"><b>Confirm
                {{ statusActivity == "checkout" ? "Check Out" : "Check In" }}</b></span>
          </v-row>
        </v-card-title>
        <br />
        <v-card-subtitle>
          <v-row justify="center">
            <span class="black--text">Are you sure you want to
              {{
                statusActivity == "checkout" ? "check out" : "check in"
              }}?</span>
          </v-row>
        </v-card-subtitle>
        <v-card-actions style="padding-top: 20px">
          <v-spacer></v-spacer>
          <v-btn depressed outlined width="120" @click="closecheckInOu" style=" text-transform: capitalize;">
            Cancel
          </v-btn>
          <v-btn depressed width="120" class="mr-3 buttonblue" @click="checkInOutConfirm()"
            style="background-color: #3682ec; color: white; text-transform: capitalize;">
            {{ statusActivity == "checkout" ? "Check Out" : "Check In" }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import { Loader } from "@googlemaps/js-api-loader";
import moment from "moment";
export default {
  name: "Dashboard",
  data() {
    return {
      sec_acc_my_time_off: false,
      sec_acc_approve_time_off: false,
      sec_acc_time_attendance: false,
      sec_acc_out_of_office: false,
      sec_acc_list: [],

      leave_list: [],
      leave_number: "0",
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      th_name: "",
      eng_name: "",
      worker_time: "",
      sick_day: 0,
      sick_hours: 0.0,
      vacation_day: 0,
      pending_cont: 0,
      vacation_hours: 0.0,
      leavehistory_list: [],
      leaveApprove_list: [],
      datenow_show: null,
      timenow_show: null,
      expecttime: null,
      statusActivity: "",
      checkindate: null,
      dialogcCheckIn: false,
      currentTime: "",
      dataActivivty: {},
      duration: 0,
      update_id: 0,
      location_lat: null,
      location_lng: null,
      wasDenied: false,
      map: null,
      marker: null,
      loaderInstance: null,
      isLocating: false,
    };
  },
  components: {
    SuccessDialog,
  },
  async mounted() {
    try {
      await api.checkVersion();

      const userId = localStorage.getItem(server.USER_ID);
      if (!userId || !api.isLoggedIn()) {
        this.$store.state.isLogged = false;
        this.$router.push("/login");
        return;
      }

      localStorage.setItem(server.MODELMENU, 0);

      // โหลดข้อมูลทั้งหมด
      await Promise.all([
        this.getSectionData(),
        this.loadActivityData(),
        this.loadEmpdata(),
        this.loadQuota(),
        this.loadleaveHistory(),
        this.loadleaveApprove(),
        this.loadLeave(),
      ]);

      this.$hideLoader();

      // ตั้ง interval
      setInterval(this.updateTime, 1000);
      setInterval(this.initMap, 300000);

      // เช็ค geolocation permission
      if (navigator.permissions) {
        const permissionStatus = await navigator.permissions.query({
          name: "geolocation",
        });

        if (permissionStatus.state === "denied") {
          this.wasDenied = true;
        }

        permissionStatus.onchange = () => {
          if (this.wasDenied && permissionStatus.state === "granted") {
            location.reload();
          }
        };
      }
    } catch (error) {
      this.$hideLoader();
    }
  },
  methods: {
    async getSectionData() {
      const result = await api.getSectionAccessConfig_By_CompanyID(
        localStorage.getItem(server.COMPANYID),
      );

      let my_positions_id = parseInt(localStorage.getItem(server.POSITION_ID));

      // ตั้งค่าเริ่มต้น
      this.sec_acc_approve_time_off = false;
      this.sec_acc_my_time_off = false;
      this.sec_acc_time_attendance = false;
      this.sec_acc_out_of_office = false;

      // ✅ เช็คว่า result.data มีข้อมูลก่อน
      if (!result.data || result.data.length === 0) {
        this.$hideLoader();
        return;
      }

      for (const section of result.data) {
        // ✅ เช็คว่า section_id มีค่า
        if (!section.section_id) {
          continue;
        }

        // ✅ เช็คว่า position_id เป็น array
        if (!Array.isArray(section.position_id)) {
          continue;
        }

        const hasAccess = section.position_id.includes(
          my_positions_id.toString(),
        );

        switch (section.section_id) {
          case "SEC-001":
            this.sec_acc_approve_time_off = hasAccess;
            break;
          case "SEC-002":
            this.sec_acc_my_time_off = hasAccess;
            break;
          case "SEC-003":
            this.sec_acc_time_attendance = hasAccess;
            break;
          case "SEC-004":
            this.sec_acc_out_of_office = hasAccess;
            break;
          default:
            break;
        }
      }

      this.sec_acc_list = result.data;
      this.$hideLoader();
    },

    async initMap() {
      const defaultLatLng = { lat: 13.7563, lng: 100.5018 };

      if (!this.loaderInstance) {
        this.loaderInstance = new Loader({
          apiKey: "AIzaSyBi65wGqm0gq3E3gKUK7DQp99rIKiVYEmc",
          version: "weekly",
          libraries: ["places"],
        });
      }

      try {
        await this.loaderInstance.load();
      } catch (err) {
        return;
      }

      const mapElement = await this.waitForElement("map", 2000);
      if (!mapElement) {
        return;
      }

      const centerLatLng =
        this.location_lat !== null && this.location_lng !== null
          ? { lat: this.location_lat, lng: this.location_lng }
          : defaultLatLng;

      if (!this.map || this.map.getDiv() !== mapElement) {
        this.map = new google.maps.Map(mapElement, {
          center: centerLatLng,
          zoom: 13,
        });
        this.marker = null;
      }

      // ✅ เช็คก่อนว่า browser รองรับ geolocation ไหม
      if (!navigator.geolocation) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Location Not Supported",
          "อุปกรณ์หรือเบราว์เซอร์นี้ไม่รองรับการระบุตำแหน่ง",
          "text-h5 red--text text-center",
        );
        return;
      }

      // ✅ เช็ค permission ก่อนขอตำแหน่ง (เพื่อแจ้งเตือนล่วงหน้าถ้าถูกปิด)
      if (navigator.permissions) {
        try {
          const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
          if (permissionStatus.state === "denied") {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Location Access Denied",
              "กรุณาเปิดสิทธิ์การเข้าถึงตำแหน่งในเบราว์เซอร์ เพื่อใช้งานฟีเจอร์นี้",
              "text-h5 red--text text-center",
            );
            return; // ไม่ต้องเรียก getCurrentPosition ต่อ เพราะรู้อยู่แล้วว่าจะ fail
          }
        } catch (e) {
          // permissions API not supported by this browser; continue to getCurrentPosition
        }
      }

      if (this.location_lat === null && this.location_lng === null) {
        this.$showLoader();
        this.isLocating = true;

        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.isLocating = false;
            const lat = parseFloat(position.coords.latitude.toFixed(4));
            const lng = parseFloat(position.coords.longitude.toFixed(4));
            this.location_lat = lat;
            this.location_lng = lng;
            this.map.setCenter({ lat, lng });
            this.updateMarkerPosition(lat, lng);
            this.$hideLoader();
          },
          (err) => {
            this.isLocating = false;
            this.$hideLoader();

            // ✅ แจ้งเตือน user ตามสาเหตุจริงของ error
            let msg = "ไม่สามารถระบุตำแหน่งได้ กรุณาลองใหม่อีกครั้ง";
            if (err.code === err.PERMISSION_DENIED) {
              msg = "กรุณาเปิดสิทธิ์การเข้าถึงตำแหน่งในเบราว์เซอร์ เพื่อใช้งานฟีเจอร์นี้";
            } else if (err.code === err.TIMEOUT) {
              msg = "ค้นหาตำแหน่งใช้เวลานานเกินไป กรุณาลองใหม่ในที่ที่สัญญาณดีกว่านี้";
            } else if (err.code === err.POSITION_UNAVAILABLE) {
              msg = "ไม่สามารถระบุตำแหน่งปัจจุบันได้ในขณะนี้";
            }

            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Location Error",
              msg,
              "text-h5 red--text text-center",
            );
          },
          {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: 60000,
          }
        );
      } else {
        this.updateMarkerPosition(this.location_lat, this.location_lng);
      }
    },
    waitForElement(id, timeoutMs) {
      return new Promise((resolve) => {
        const start = Date.now();
        const check = () => {
          const el = document.getElementById(id);
          if (el) {
            resolve(el);
          } else if (Date.now() - start > timeoutMs) {
            resolve(null);
          } else {
            requestAnimationFrame(check);
          }
        };
        check();
      });
    },

    updateMarkerPosition(lat, lng) {
      const position = { lat, lng };

      if (this.marker) {
        // มี marker อยู่แล้ว แค่ย้ายตำแหน่ง ไม่ต้องสร้างใหม่
        this.marker.setPosition(position);
      } else {
        this.marker = new google.maps.Marker({
          position,
          map: this.map,
          title: "You are here",
          icon: {
            url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
          },
        });
      }
    },
    updateTime() {
      ///โหดล เเบบเรียวทาม
      const now = new Date();

      // แปลงเวลาตาม 12-hour format (AM/PM)
      const hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const period = hours >= 12 ? "PM" : "AM"; // AM/PM
      const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

      // convert 0 to 12 for 12-hour format
      this.currentTime = `${formattedHours}:${minutes} ${period}`;

      if (this.statusActivity == "checkin") {
        this.loadDataChecKIN();
      } else if (this.statusActivity == "checkout") {
        if (this.dataActivivty) {
          this.loadDataChecKOut(this.dataActivivty);
        }
      } else {
        return;
      }
    },
    async loadLeave() {

      var data_leave_set = {
        date_now: new Date().toISOString().split("T")[0],
        company_id: Number(localStorage.getItem(server.COMPANYID)),
      };
      const res_leave = await api.getToDashboard({ params: data_leave_set });
      var dataleave = Object.values(
        res_leave.data.reduce((acc, item) => {
          // สร้าง key โดยไม่เอา amount
          const key = `${item.userid}-${item.strc_date}`;

          if (!acc[key]) {
            acc[key] = { ...item };
          } else {
            acc[key].amount = Number(item.amount) + Number(acc[key].amount);
          }

          return acc;
        }, {})
      );
      this.leave_list = dataleave;
      this.leave_number = dataleave.length;

      for (const [index, item] of this.leave_list.entries()) {
        if (item.image_profile != "" && item.image_profile != null) {
          item.image_profile = imageUrl + "/" + item.image_profile;
        } else {
          item.image_profile = "";
        }

        var leave_day = 0;
        var leave_hours = 0;

        leave_day = Math.floor(Number(item.amount) / 60 / 8);
        leave_hours = Number(Number(item.amount) / 60) - leave_day * 8;

        if (leave_day == 0) {
          if (leave_hours == 0) {
            item.description = ``;
          } else if (leave_hours == 4) {
            item.description = item.description = `Half Day`;
          } else if (leave_hours == 8) {
            item.description = item.description = `Full Day`;
          } else {
            item.description = item.description = `${leave_hours} Hours`;
          }
        } else {
          if (leave_hours == 0) {
            if (leave_day > 1) {
              item.description = `${leave_day} Day`;
            } else {
              item.description = `Full Day`;
            }
          } else {
            item.description = item.description = `${leave_day} Day ${leave_hours} Hours`;
          }
        }
      }
      // this.leave_list = []
    },
    async loadActivityData() {
      const resCheckInData = await api.getCheckinDateWeb(
        localStorage.getItem(server.USER_ID),
      );


      if (resCheckInData.data.length > 0) {
        resCheckInData.data[0].checkindate = moment(
          resCheckInData.data[0].checkindate
        )
          .subtract(7, "hours")
          .format("YYYY-MM-DD HH:mm:ss");

        resCheckInData.data[0].checkInDate_Date = resCheckInData.data[0].checkindate;

        this.statusActivity = "checkout";

        this.location_lng = resCheckInData.data[0].location_lng;
        this.location_lat = resCheckInData.data[0].location_lat;

        this.update_id = resCheckInData.data[0].id;
        this.dataActivivty = resCheckInData.data[0];

        var checkinDate = new Date(resCheckInData.data[0].checkInDate_Date);
        //เซต เวลา checkin
        const formattedStartTime = checkinDate.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
        this.checkindate = `${formattedStartTime}`;

        // เพิ่มเวลา 9 ชั่วโมง
        const expectTime = new Date(checkinDate.getTime() + 9 * 60 * 60 * 1000); // เพิ่ม 9 ชั่วโมง (9 * 60 * 60 * 1000 ms)
        const formattedExpectDate = expectTime.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
        });
        const formattedExpectTime = expectTime.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });

        // สร้างค่า expecttime
        this.expecttime = `${formattedExpectTime}`;

        this.loadDataChecKOut(this.dataActivivty);
      } else {
        this.location_lng = null;
        this.location_lat = null;
        this.statusActivity = "checkin";
        this.dataActivivty = {};
        this.loadDataChecKIN();
      }
      await this.$nextTick();
      this.initMap();
    },
    loadDataChecKIN() {
      const now = new Date();

      //checkin datetime
      const formattedStartDate = now.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const formattedStartTime = now.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      this.checkindate = `${formattedStartDate}, ${formattedStartTime}`;

      // เพิ่มเวลา 9 ชั่วโมง
      const expectTime = new Date(now.getTime() + 9 * 60 * 60 * 1000); // เพิ่ม 9 ชั่วโมง (9 * 60 * 60 * 1000 ms)
      const formattedExpectDate = expectTime.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const formattedExpectTime = expectTime.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });

      // สร้างค่า expecttime
      this.expecttime = `${formattedExpectTime}`;

      //date show
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
      };

      // ใช้ Intl.DateTimeFormat เพื่อให้แน่ใจว่าการแสดงผลถูกต้อง
      const formatter = new Intl.DateTimeFormat("en-US", options);
      const parts = formatter.formatToParts(now);

      // ดึงค่าจาก parts เพื่อเรียงข้อมูลใหม่
      let weekday = "";
      let month = "";
      let day = "";
      let year = "";

      parts.forEach(({ type, value }) => {
        if (type === "weekday") weekday = value;
        if (type === "month") month = value;
        if (type === "day") day = value;
        if (type === "year") year = value;
      });

      const finalFormattedDate = `${month} ${day}, ${year} (${weekday})`;
      this.datenow_show = finalFormattedDate;
    },
    loadDataChecKOut(data) {
      // this.checkindate

      //เซต datetime show
      const now = new Date();

      //date show
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
      };

      // ใช้ Intl.DateTimeFormat เพื่อให้แน่ใจว่าการแสดงผลถูกต้อง
      const formatter = new Intl.DateTimeFormat("en-US", options);
      const parts = formatter.formatToParts(now);

      // ดึงค่าจาก parts เพื่อเรียงข้อมูลใหม่
      let weekday = "";
      let month = "";
      let day = "";
      let year = "";

      parts.forEach(({ type, value }) => {
        if (type === "weekday") weekday = value;
        if (type === "month") month = value;
        if (type === "day") day = value;
        if (type === "year") year = value;
      });

      const finalFormattedDate = `${month} ${day}, ${year} (${weekday})`;
      this.datenow_show = finalFormattedDate;

      //คำนวณเวลา
      var checkinDate = new Date(data.checkInDate_Date);
      var checkoutDate = now;

      // คำนวณความแตกต่างระหว่างเวลาทั้งสอง (ในมิลลิวินาที)
      var timeDifference = checkoutDate - checkinDate;

      // แปลงมิลลิวินาทีเป็นนาที
      var timeDifferenceInMinutes = timeDifference / (1000 * 60);

      // ตรวจสอบและลดเวลาตามเงื่อนไข
      if (timeDifferenceInMinutes >= 300) {
        timeDifferenceInMinutes -= 60; // ลด 60 นาที หากเวลามากกว่า 300 นาที
      }

      // ตรวจสอบให้เวลามากสุดไม่เกิน 480 นาที
      if (timeDifferenceInMinutes > 480) {
        timeDifferenceInMinutes = 480; // จำกัดเวลาที่ 480 นาที
      }
      this.duration = Math.floor(timeDifferenceInMinutes);
      const hours = Math.floor(timeDifferenceInMinutes / 60); // คำนวณชั่วโมง
      const minutes = Math.floor(timeDifferenceInMinutes % 60);

      const formattedTimeDifference = `${hours}h ${minutes}m`;
      this.worker_time = formattedTimeDifference;
    },
    async loadEmpdata() {
      const res_emp = await api.getAccountByidMenu(
        localStorage.getItem(server.USER_ID),
      );

      this.th_name = res_emp.data[0].name;
      this.eng_name = res_emp.data[0].eng_name;
    },
    async loadQuota() {
      const res_quota = await api.getListByUserDashboard(
        localStorage.getItem(server.USER_ID),
      );
      if (res_quota.data && res_quota.data.length > 0) {
        var canuse_leave = 0;
        canuse_leave = Number(res_quota.data[0].leave_can_use);
        this.vacation_day = Math.floor(canuse_leave);
        this.vacation_hours = (canuse_leave - this.vacation_day) * 8;
      } else {
        this.vacation_day = 0;
        this.vacation_hours = 0;
      }
    },
    async loadleaveHistory() {
      const res_leave_history = await api.getListHistoryAll(
        localStorage.getItem(server.USER_ID),
      );
      if (res_leave_history.data && res_leave_history.data.length > 0) {
        const filteredData = res_leave_history.data.filter(
          (item) => Number(item.status) === 1 || Number(item.status) === 2,
        );
        this.pending_cont = filteredData.length;
      } else {
        this.pending_cont = 0;
      }
    },
    async loadleaveApprove() {
      var res_leave_approve = [];
      if (localStorage.getItem("dtime_role") == "ADMIN") {
        res_leave_approve = await api.getListAdminAll(
          localStorage.getItem(server.COMPANYID)
        );
      } else {
        res_leave_approve = await api.getListApprove(
          localStorage.getItem(server.USER_ID),
        );

      }
      const datalist_leave = res_leave_approve.data.slice(0, 5);
      for (const [index, item] of datalist_leave.entries()) {
        if (item.leave_type == "Sick Leave") {
          item.leave_type = "Sick";
        } else if (item.leave_type == "Vacation Leave") {
          item.leave_type = "Vacation";
        }
        var leave_day = 0;
        var leave_hours = 0;

        leave_day = Math.floor(Number(item.hours_amount) / 8);
        leave_hours = Number(item.hours_amount) - leave_day * 8;

        if (leave_day == 0) {
          if (leave_hours == 0) {
            item.description = `${item.data_date}`;
          } else {
            item.description = item.description = `${item.data_date} (${leave_hours} hours)`;
          }
        } else {
          if (leave_hours == 0) {
            item.description = `${item.data_date} (${leave_day} day)`;
          } else {
            item.description = item.description = `${item.data_date} (${leave_day} day ${leave_hours} hours)`;
          }
        }
        if (item.image != "" && item.image != null) {
          item.image_profile = imageUrl + "/" + item.image;
        } else {
          item.image_profile = "";
        }
      }
      console.log(datalist_leave)
      this.leaveApprove_list = datalist_leave;
    },
    async goToLeaveHistory() {
      this.$router.push("/my-time-off");
    },
    async goToLeaveHistoryById(id, status) {
      if (status == 1) {
        this.$router.push(`/leave-request-edit/${id}`);
      } else {
        this.$router.push(`/leave-request-waiting/${id}/dashboard`);
      }
    },
    async goToLeaveApprove() {
      // เปลี่ยน URL หรือทำการนำทางที่ต้องการ
      this.$router.push("/approver-time-off"); // หากคุณใช้ Vue Router
    },
    async goToLeaveApproveById(id, user_id, status) {
      // เปลี่ยน URL หรือทำการนำทางที่ต้องการ
      if (Number(status) == 3 || Number(status) == 4) {
        this.$router.push(`/leave-request-waiting/${id}/leave`);
      } else {
        this.$router.push(`/approve-leave-confirm/${id}/${user_id}`);
      }
      // หรือ window.location.href = 'URL ที่ต้องการ'; // หากคุณต้องการเปลี่ยนไปยัง URL อื่น
    },
    CheckInOut() {
      this.dialogcCheckIn = true;
    },
    closecheckInOu() {
      this.dialogcCheckIn = false;
    },
    async checkInOutConfirm() {
      this.dialogcCheckIn = false;

      // สร้างรูปแบบวันที่ตามที่ต้องการ
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // เดือนเริ่มจาก 0, ดังนั้นต้อง +1
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      // สร้างวันที่ในรูปแบบ yyyy:mm:dd HH:MM:00
      const formattedDate = `${year}:${month}:${day} ${hours}:${minutes}:00`;

      if (this.statusActivity == "checkout") {
        var dataUpdate = {};

        dataUpdate.chargeType = "";
        dataUpdate.isCheckedOut = true;
        dataUpdate.jobTitleId = 0;
        dataUpdate.customerId = 0;
        dataUpdate.prospect = "";
        dataUpdate.detail = "";
        dataUpdate.duration = this.duration;
        dataUpdate.addby = "W";

        var input = formattedDate;
        const [date, time] = input.split(' ');
        const fixedDate = date.replace(/:/g, '-');

        const result = `${fixedDate} ${time}`;
        dataUpdate.checkOutDate = result;

        this.$showLoader();
        const res_updateAct = await api.updateActivity(
          this.update_id,
          dataUpdate,
        );

        if (res_updateAct.status == 200 || res_updateAct.status == 201) {
          this.datenow_show = null;
          this.timenow_show = null;
          this.expecttime = null;
          this.checkindate = null;
          await this.loadActivityData();
          await this.loadEmpdata();
          await this.loadQuota();
          await this.loadleaveHistory();
          await this.loadleaveApprove();
          this.$hideLoader();

          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
          );
          return;
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center",
          );
          return;
        }
      } else {

        if (navigator.permissions) {
          const permissionStatus = await navigator.permissions.query({
            name: "geolocation",
          });
          if (permissionStatus.state === "denied") {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "To use this feature, please allow location access in your browser settings.",
              "text-h5 red--text text-center",
            );
            return; //หยุดทำงานต่อ
          }
        }

        var addItem = {};
        addItem.location_lat = this.location_lat;
        addItem.location_lng = this.location_lng;
        addItem.chargeType = "";
        addItem.company_id = Number(localStorage.getItem(server.COMPANYID));
        addItem.isCheckedOut = 0;
        addItem.userId = Number(localStorage.getItem(server.USER_ID));
        addItem.departmentId = Number(
          localStorage.getItem(server.DEPARTMENT_ID),
        );
        addItem.jobTitleId = 0;
        addItem.customerId = 0;
        addItem.prospect = "";
        addItem.detail = "";
        addItem.addby = "W";
        addItem.check_auto = 0;
        addItem.status = "A";

        var input = formattedDate;
        const [date, time] = input.split(' ');
        const fixedDate = date.replace(/:/g, '-');

        const result = `${fixedDate} ${time}`;
        addItem.checkInDate = result;

        this.$showLoader();
        const res_addAct = await api.createActivityCheckin(addItem);
        if (res_addAct.status == 200 || res_addAct.status == 201) {
          this.datenow_show = null;
          this.timenow_show = null;
          this.expecttime = null;
          this.checkindate = null;
          await this.loadActivityData();
          await this.loadEmpdata();
          await this.loadQuota();
          await this.loadleaveHistory();
          await this.loadleaveApprove();
          this.$hideLoader();

          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
          );
          return;
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center",
          );
          return;
        }
      }
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.hover-bg {
  transition: background-color 0.3s ease;
}

.hover-bg:hover {
  background-color: #daf2fa;
  /* สีที่ต้องการเมื่อ hover */
}
</style>